import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import Icon from './Icon'

const DatePickerWithIcon = (props) => {
    return <span className="DatePickerWithIcon">
        <DatePicker {...props} />
        <Icon icon="calendar" height={16} width={16} />
    </span>
}

export default DatePickerWithIcon